import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/turkmer/application', config);
}
const store = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/turkmer/application/save',formData,{
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/turkmer/application/show/'+id);
}

const showUser = async (id, config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/turkmer/application/show-user/'+id, config);
}

const update = async (id,formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/turkmer/application/update/'+id,formData);
}
const downloadDocuments = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;

    return Api.get('/turkmer/application/document-download',config);
}
const downloadAdminDocuments = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;

    return Api.get('/turkmer/application/document-download/admin',config);
}
const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/turkmer/application/excel-export',config);
}
const approveDocument = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/turkmer/application/document-approve`, data);
};

const sendRegister = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/turkmer/application/send-register');
}
const uploadDocument = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/turkmer/application/document-upload`, data);
};
const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/turkmer/application/' + id);
}

export default {
    getAll,
    show,
    showUser,
    update,
    store,
    downloadDocuments,
    downloadAdminDocuments,
    excelExport,
    approveDocument,
    sendRegister,
    uploadDocument,
    del
}
